import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import useQuery, { _get, toCurrency } from "../../Utils/Helper";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import { acadamicTerms } from "../../../core/common/selectoption/selectoption";
import { SingleValue } from "react-select";
import AcademicYearSelect from "../../../core/common/AcademicYearSelect";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import ParentPayModals from "../../peoples/students/ParentPayModals";
import StudentReceiptModals from "../../peoples/students/StudentReceiptModals";

interface Class {
  class_name: string;
  student_name: string;
  admission_no: string;
  term: string;
  total_invoice: number;
  total_paid: number;
  balance: number;
}

const FamilyBillProcess: React.FC = () => {
  const routes = all_routes;
  const { user } = useSelector((state: RootState) => state.auth);
  const q = useQuery();

  const [classes, setClasses] = useState<Class[]>([]);
  const [form, setForm] = useState({
    class_name: q.get("class_name") || "",
    term: q.get("term") || "",
    academic_year: q.get("academic_year") || "",
    admission_no: "",
    student_name: "",
  });

  useEffect(() => {
    _get(
      `payments?query_type=select-family-bills&id=${user.id}&class_name=${form.class_name}&term=${form.term}&academic_year=${form.academic_year}`,
      (res) => {
        if (res && res.data) {
          setClasses(res.data);
        } else {
          console.error("Unexpected response format:", res);
        }
      },
      (err) => {
        console.error("Error fetching classes:", err);
      }
    );
  }, [form.class_name, form.term, form.academic_year]);

  const columns = [
    {
      title: "#",
      dataIndex: "class_name",
      render: (text: string, record: any, index: number) => (
        <span>{index + 1}</span>
      ),
    },
    {
      title: "Child Name",
      dataIndex: "student_name",
      render: (text: string, record: any) => (
        <Link to="#" className="link-primary">
          <h4 className="btn-link text-primary">{text}</h4>
          <sup>{record.admission_no}</sup>
        </Link>
      ),
    },
    {
      title: "Class",
      dataIndex: "class_name",
      render: (text: string, record: any) => (
        <div>
          <h4>{text}</h4>
          <sup>{record.term}</sup>
        </div>
      ),
    },
    {
      title: "Invoice",
      dataIndex: "total_invoice",
      render: (text: number) =>
        text > 0 ? <span>{toCurrency(text)}</span> : <span>N/A</span>,
    },
    {
      title: "Amount Paid",
      dataIndex: "total_paid",
      render: (text: number) =>
        text > 0 ? <span>{toCurrency(text)}</span> : <span>N/A</span>,
    },
    {
      title: "Action",
      dataIndex: "balance",
      render: (balance: number, record: any) => (
        <>
          {balance > 0 ? (
            <button
              className="btn btn-info"
              data-bs-toggle="modal"
              data-bs-target="#student_payment_modal"
              onClick={() =>
                setForm((prev) => ({
                  ...prev,
                  student_name: record.student_name,
                  admission_no: record.admission_no,
                }))
              }
            >
              Preview {toCurrency(balance)}
            </button>
          ) : record.total_paid > 0 ? (
            <button
              className="btn btn-success"
              data-bs-toggle="modal"
              data-bs-target="#student_receipt_modal"
              onClick={() =>
                setForm((prev) => ({
                  ...prev,
                  student_name: record.student_name,
                  admission_no: record.admission_no,
                }))
              }
            >
              Print Receipt
            </button>
          ) : (
            "N/A"
          )}
        </>
      ),
    },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              {/* <h3 className="page-title mb-1">Payment & Receipt</h3> */}
              {/* <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Fees Collection</Link>
                  </li>
                  <li className="breadcrumb-item active">Payment & Receipt</li>
                </ol>
              </nav> */}
            </div>
          </div>
          {/* /Page Header */}

          {/* Students List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Payment & Receipt</h4>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Academic Year</label>
                    <AcademicYearSelect
                      onChange={(year) =>
                        setForm((prev) => ({ ...prev, academic_year: year }))
                      }
                      selectedYear={form.academic_year}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Term</label>
                    <CommonSelect
                      className="select"
                      options={acadamicTerms}
                      defaultValue={{ label: form.term, value: form.term }}
                      handleChange={(newValue: SingleValue<Option>) =>
                        setForm((prev) => ({
                          ...prev,
                          term: newValue ? newValue.value : "",
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body p-0 py-3">
              {/* Student List */}
              <Table dataSource={classes} columns={columns} Selection={false} />
              {/* /Student List */}
            </div>
          </div>
          {/* /Students List */}
        </div>
      </div>

      {/* Modals */}
      <ParentPayModals
        admission_no={form.admission_no}
        term={form.term}
        academic_year={form.academic_year}
        student_name={form.student_name}
      />
      <StudentReceiptModals
        admission_no={form.admission_no}
        term={form.term}
        academic_year={form.academic_year}
        student_name={form.student_name}
      />
    </>
  );
};

export default FamilyBillProcess;
